import React from 'react';
import { Link } from 'react-router-dom';

function TermsConditions() {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-6 max-w-4xl">
        {/* Header */}
        <div className="mb-8">
          <Link to="/" className="text-blue-600 hover:text-blue-700 font-medium inline-flex items-center mb-4">
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7"></path>
            </svg>
            Volver al Inicio
          </Link>
          <h1 className="text-4xl font-bold text-gray-900 mb-2">Términos y Condiciones</h1>
          <p className="text-gray-600">Última actualización: 6 de agosto de 2025</p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg shadow-sm p-8">
          <div className="prose max-w-none">
            
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Aceptación de los Términos</h2>
              <p className="text-gray-700 mb-4">
                Al descargar, instalar o utilizar la aplicación móvil "Facturas Simples" (en adelante, "la Aplicación"), usted acepta estar sujeto a estos Términos y Condiciones (en adelante, "los Términos"). Si no está de acuerdo con estos términos, no utilice la Aplicación.
              </p>
              <p className="text-gray-700 mb-4">
                Estos Términos constituyen un acuerdo legal entre usted ("Usuario") y K Labs Sa de CV ("Nosotros", "Nuestro", "la Empresa"), desarrollador de la Aplicación.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Descripción del Servicio</h2>
              <p className="text-gray-700 mb-4">
                Facturas Simples es una aplicación móvil diseñada para facilitar la generación de documentos tributarios electrónicos (DTE) y facturación electrónica para empresas y emprendedores en México. La Aplicación permite:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Creación y gestión de facturas electrónicas</li>
                <li>Generación de documentos en formato PDF</li>
                <li>Envío automático de facturas por correo electrónico</li>
                <li>Sincronización con iCloud</li>
                <li>Gestión multi-empresa</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Compras Dentro de la Aplicación</h2>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-3">3.1 Paquetes de Facturas</h3>
              <p className="text-gray-700 mb-4">
                La Aplicación ofrece varios paquetes de facturas disponibles para compra a través del App Store de Apple:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li><strong>Paquete Esencial:</strong> 25 facturas por $4.90 USD</li>
                <li><strong>Paquete Inicial:</strong> 50 facturas por $9.99 USD</li>
                <li><strong>Paquete Profesional:</strong> 100 facturas por $15.00 USD</li>
                <li><strong>Paquete Empresarial:</strong> 250 facturas por $29.99 USD</li>
                <li><strong>Enterprise Pro Mensual:</strong> Facturas ilimitadas por $99.99 USD/mes</li>
                <li><strong>Enterprise Pro Anual:</strong> Facturas ilimitadas por $999.99 USD/año</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">3.2 Términos de Compra</h3>
              <p className="text-gray-700 mb-4">
                • Los paquetes de facturas (excepto las suscripciones) son <strong>consumibles sin fecha de expiración</strong>, funcionando como talonarios digitales hasta agotarse.
              </p>
              <p className="text-gray-700 mb-4">
                • Las suscripciones se renuevan automáticamente a menos que se cancelen al menos 24 horas antes del final del período actual.
              </p>
              <p className="text-gray-700 mb-4">
                • Todas las compras se procesan a través del App Store de Apple y están sujetas a los términos y condiciones de Apple.
              </p>
              <p className="text-gray-700 mb-4">
                • Los precios pueden variar según el país y están sujetos a cambios sin previo aviso.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">3.3 Política de Reembolsos</h3>
              <p className="text-gray-700 mb-4">
                Los reembolsos están sujetos a las políticas del App Store de Apple. Para solicitar un reembolso, debe contactar directamente al soporte de Apple a través de su ID de Apple o la configuración del App Store.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Uso Aceptable</h2>
              <p className="text-gray-700 mb-4">
                El Usuario se compromete a utilizar la Aplicación de manera legal y ética. Está prohibido:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Utilizar la Aplicación para fines ilegales o fraudulentos</li>
                <li>Generar facturas falsas o con información incorrecta</li>
                <li>Compartir credenciales de acceso con terceros</li>
                <li>Intentar eludir las medidas de seguridad de la Aplicación</li>
                <li>Realizar ingeniería inversa o descompilar la Aplicación</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Privacidad y Protección de Datos</h2>
              <p className="text-gray-700 mb-4">
                Su privacidad es importante para nosotros. Nuestra recolección y uso de información personal se rige por nuestra <Link to="/privacy-policy" className="text-blue-600 hover:text-blue-700">Política de Privacidad</Link>, que forma parte integral de estos Términos.
              </p>
              <p className="text-gray-700 mb-4">
                Los datos de facturación se almacenan localmente en su dispositivo y pueden sincronizarse con iCloud si está habilitado. No tenemos acceso a sus datos de facturación personal.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Propiedad Intelectual</h2>
              <p className="text-gray-700 mb-4">
                La Aplicación, incluyendo su diseño, código, contenido y funcionalidades, es propiedad de K Labs Sa de CV y está protegida por las leyes de derechos de autor y propiedad intelectual de México y tratados internacionales.
              </p>
              <p className="text-gray-700 mb-4">
                Se otorga al Usuario una licencia limitada, no exclusiva e intransferible para utilizar la Aplicación según estos Términos.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Disponibilidad del Servicio</h2>
              <p className="text-gray-700 mb-4">
                Aunque nos esforzamos por mantener la Aplicación disponible las 24 horas del día, no garantizamos el acceso ininterrumpido. El servicio puede verse interrumpido por mantenimiento, actualizaciones o circunstancias fuera de nuestro control.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Limitación de Responsabilidad</h2>
              <p className="text-gray-700 mb-4">
                En la máxima medida permitida por la ley, K Labs Sa de CV no será responsable por:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Daños indirectos, incidentales o consecuentes</li>
                <li>Pérdida de datos, ganancias o interrupciones del negocio</li>
                <li>Errores en documentos fiscales generados por el Usuario</li>
                <li>Cumplimiento con regulaciones fiscales locales</li>
              </ul>
              <p className="text-gray-700 mb-4">
                Es responsabilidad del Usuario verificar la exactitud de todos los documentos fiscales generados y cumplir con las obligaciones fiscales aplicables.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Terminación</h2>
              <p className="text-gray-700 mb-4">
                Estos Términos permanecen en vigor hasta que sean terminados por cualquiera de las partes. Podemos terminar o suspender su acceso a la Aplicación en cualquier momento, sin previo aviso, por violación de estos Términos.
              </p>
              <p className="text-gray-700 mb-4">
                El Usuario puede terminar estos Términos eliminando la Aplicación de su dispositivo.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Ley Aplicable</h2>
              <p className="text-gray-700 mb-4">
                Estos Términos se regirán e interpretarán de acuerdo con las leyes de México. Cualquier disputa se resolverá en los tribunales competentes de México.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">11. Modificaciones</h2>
              <p className="text-gray-700 mb-4">
                Nos reservamos el derecho de modificar estos Términos en cualquier momento. Las modificaciones entrarán en vigor inmediatamente después de su publicación en la Aplicación o en nuestro sitio web.
              </p>
              <p className="text-gray-700 mb-4">
                El uso continuado de la Aplicación después de las modificaciones constituye la aceptación de los nuevos términos.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">12. Contacto</h2>
              <p className="text-gray-700 mb-4">
                Si tiene preguntas sobre estos Términos y Condiciones, puede contactarnos:
              </p>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-700 mb-2"><strong>K Labs Sa de CV</strong></p>
                <p className="text-gray-700 mb-2">Email: <Link to="/contact" className="text-blue-600 hover:text-blue-700">Formulario de Contacto</Link></p>
                <p className="text-gray-700">Sitio web: <a href="https://facturas-simples.com" className="text-blue-600 hover:text-blue-700">https://facturas-simples.com</a></p>
              </div>
            </section>

            <section className="mb-8 border-t pt-6">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Información Específica para iOS y App Store</h2>
              <p className="text-gray-700 mb-4">
                Esta aplicación está disponible exclusivamente a través del App Store de Apple y está sujeta a:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Los términos y condiciones del App Store de Apple</li>
                <li>Las políticas de compras dentro de la aplicación de Apple</li>
                <li>Los estándares de revisión de aplicaciones de Apple</li>
              </ul>
              <p className="text-gray-700 mb-4">
                Apple no es parte de estos Términos y Condiciones y no es responsable por la Aplicación o su contenido.
              </p>
            </section>

          </div>
        </div>

        {/* Footer Links */}
        <div className="mt-8 text-center">
          <div className="flex flex-wrap justify-center gap-6 text-sm">
            <Link to="/" className="text-blue-600 hover:text-blue-700">Inicio</Link>
            <Link to="/privacy-policy" className="text-blue-600 hover:text-blue-700">Política de Privacidad</Link>
            <Link to="/contact" className="text-blue-600 hover:text-blue-700">Contacto</Link>
            <Link to="/faq" className="text-blue-600 hover:text-blue-700">FAQ</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsConditions;
